import AlertIcon from '@repo/ui/src/components/Icons/AlertIcon';

const ErrorState = ({ text }: { text?: string }) => {
  if (!text) return null;

  return (
    <div className="flex gap-2 py-5 px-6 bg-red-100 border-red-400 border-2">
      <AlertIcon className="w-5 h-5 shrink-0" />
      <p className="tra-text-web-body-m">{text}</p>
    </div>
  );
};

export default ErrorState;
